import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getOpenedTaskComments } from '../../../../../redux/tasks/taskEntities/selectors';

const TaskDetailsCommentsTabLabel = ({ taskComments }) => {
  const intl = useIntl();

  const [comments, setComments] = useState(taskComments?.filter((c) => c?.type !== 'activity') || []);

  const commentCount = useMemo(() => comments?.length, [comments]);

  useEffect(() => {
    setComments(taskComments?.filter((c) => c?.type !== 'activity') || []);
  }, [taskComments]);

  return `${intl.formatMessage({ id: 'COMMENTS', defaultMessage: 'Comments' })} ${commentCount > 0 ? `(${commentCount})` : ''}`;
};

const mapStateToProps = (state) => {
  return {
    taskComments: getOpenedTaskComments(state),
  };
};

export default connect(mapStateToProps)(TaskDetailsCommentsTabLabel);
